import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductDetailsService {


  private data = new BehaviorSubject('');
  currentData = this.data.asObservable()

  constructor() { }
  // Initialize the cartProducts array
  private cartProductsSubject = new BehaviorSubject<any[]>([]);

  // Observable to expose the cartProducts array to other components
  cartProducts$ = this.cartProductsSubject.asObservable();

  // Method to update the cart products array
  updateCartProducts(products: any[]) {
    this.cartProductsSubject.next(products);
  }

  // Method to add a product to the cart
  addProductToCart(product: any) {
    const currentCart = this.cartProductsSubject.value;
    this.cartProductsSubject.next([...currentCart, product]);
  }
}
